import messages from './Messages.vue';

export default messages;



// WEBPACK FOOTER //
// ./src/components/parts/messages/index.ts